import React, { useCallback, useEffect, useState, useRef } from "react";
import { useDebounce } from "../hooks/useDebounce";
import { modifierPrice } from "../helpers/modifierPrice";

const RangeSlider = ({ min, max, onChange, type }) => {
	const [minVal, setMinVal] = useState(min);
	const [maxVal, setMaxVal] = useState(max);
	const minValRef = useRef(min);
	const maxValRef = useRef(max);
	const range = useRef(null);

	const getPercent = useCallback(
		(value) => Math.round(((value - min) / (max - min)) * 100),
		[min, max]
	);

	const debouncedMinVal = useDebounce(minVal, 500);
  	const debouncedMaxVal = useDebounce(maxVal, 500);

	useEffect(() => {
		const minPercent = getPercent(minVal);
		const maxPercent = getPercent(maxVal);

		if (range.current) {
			range.current.style.left = `${minPercent}%`;
			range.current.style.width = `${maxPercent - minPercent}%`;
		}
	}, [minVal, getPercent]);

	useEffect(() => {
		const minPercent = getPercent(minVal);
		const maxPercent = getPercent(maxVal);

		if (range.current) {
			range.current.style.width = `${maxPercent - minPercent}%`;
		}
	}, [maxVal, getPercent]);

	useEffect(() => {
		onChange({ min: minVal, max: maxVal });
	}, [debouncedMinVal, debouncedMaxVal]);

	return (
		<>
			<div className="container">
				<input
					type="range"
					min={min}
					max={max}
					value={minVal}
					onChange={(event) => {
						const value = Math.min(Number(event.target.value), maxVal - 1);
						setMinVal(value);
						minValRef.current = value;
					}}
					className="thumb thumb--left"
					style={{ zIndex: minVal > max - 100 && "5" }}
				/>
				<input
					type="range"
					min={min}
					max={max}
					value={maxVal}
					onChange={(event) => {
						const value = Math.max(Number(event.target.value), minVal + 1);
						setMaxVal(value);
						maxValRef.current = value;
					}}
					className="thumb thumb--right"
				/>

				<div className="slider">
					<div className="slider__track" />
					<div ref={range} className="slider__range" />
					<div className="slider__left-value">{type === 'price' ? modifierPrice(minVal) : minVal}</div>
					<div className="slider__right-value">{type === 'price' ? modifierPrice(maxVal) : maxVal}</div>
				</div>
			</div>
		</>
	);
}

export default RangeSlider;
